import {
  RelatorioGeralSchema,
  DesempenhoSerieSchema,
  PorStatusSchema,
  PorCategoriaSchema,
  TopEventosResponseSchema,
  type PeriodoFilter,
  type RelatorioGeral,
  type DesempenhoSerie,
  type PorStatus,
  type PorCategoria,
  type TopEventosResponse,
  type TopEventosFilter,
} from '@lance-x/shared';
import type { ApiClient } from '../index';

export class RelatoriosEndpoints {
  constructor(private readonly client: ApiClient) {}

  private periodoQuery(filter?: PeriodoFilter) {
    const query: Record<string, string | number | undefined> = {};
    if (filter?.dataDe) query['dataDe'] = filter.dataDe;
    if (filter?.dataAte) query['dataAte'] = filter.dataAte;
    if (filter?.granularidade) query['granularidade'] = filter.granularidade;
    return query;
  }

  geral(filter?: PeriodoFilter): Promise<RelatorioGeral> {
    return this.client.get('/relatorios/empresa/geral', {
      query: this.periodoQuery(filter),
      responseSchema: RelatorioGeralSchema,
    });
  }

  desempenho(filter?: PeriodoFilter): Promise<DesempenhoSerie> {
    return this.client.get('/relatorios/empresa/desempenho', {
      query: this.periodoQuery(filter),
      responseSchema: DesempenhoSerieSchema,
    });
  }

  porStatus(filter?: PeriodoFilter): Promise<PorStatus> {
    return this.client.get('/relatorios/empresa/por-status', {
      query: this.periodoQuery(filter),
      responseSchema: PorStatusSchema,
    });
  }

  porCategoria(filter?: PeriodoFilter): Promise<PorCategoria> {
    return this.client.get('/relatorios/empresa/por-categoria', {
      query: this.periodoQuery(filter),
      responseSchema: PorCategoriaSchema,
    });
  }

  topEventos(filter?: TopEventosFilter): Promise<TopEventosResponse> {
    const query: Record<string, string | number | undefined> = {};
    if (filter?.limit !== undefined) query['limit'] = filter.limit;
    if (filter?.por !== undefined) query['por'] = filter.por;
    if (filter?.dataDe !== undefined) query['dataDe'] = filter.dataDe;
    if (filter?.dataAte !== undefined) query['dataAte'] = filter.dataAte;
    return this.client.get('/relatorios/empresa/top-eventos', {
      query,
      responseSchema: TopEventosResponseSchema,
    });
  }
}
